export default __webpack_public_path__ + "40913f3e56f0d096d8b1e4a85f50cea2.png";